import { ClientReducerState } from 'client/reducers';

export const useIsSelected = (nodeID: string) => (state: ClientReducerState) => {
	return state.editor.selection.clicked[nodeID];
};
